<div class="linkedin-section">
  <div class="linkedin-section-header" (click)="toggle()">
    <span>LinkedIn</span>
    <span class="linkedin-toggle-icon">{{ isExpanded ? '—' : '+' }}</span>
  </div>
  <div class="linkedin-rows" *ngIf="isExpanded">
    <div class="social-load-error" *ngIf="loadFailed()">
      Couldn't load this brand's saved LinkedIn terms — the section is disabled and saving won't change it. Reopen the drawer to retry.
    </div>
    <div class="linkedin-header">
      <span class="linkedin-col-term">Search term</span>
      <span class="linkedin-col-countries">Countries</span>
      <span class="linkedin-col-active">Active</span>
      <span class="linkedin-col-delete"></span>
    </div>
    <div class="linkedin-row" *ngFor="let row of terms.controls; let i = index">
      <div class="linkedin-row-fields">
        <div class="linkedin-term">
          <app-titled-input [control]="getSearchTermControl(i)">
            <input
              type="text"
              [formControl]="getSearchTermControl(i)"
              placeholder="Enter a search term"
              (blur)="checkAndAddRow(i)">
          </app-titled-input>
        </div>
        <app-select-menu
          [items]="countryOptions" [placeholder]="'Select countries'"
          [selectMode]="SelectMode.MULTI" [searchable]="true" [showSelectedIcon]="true"
          [selectAllAndClearOptions]="true"
          [iconStyle]="{ 'border-radius': '50%', 'object-fit': 'cover' }"
          [control]="getCountriesControl(i)"
          [disabled]="loadFailed()"
          appendTo="body" dropDownPosition="auto"
          (onApply)="checkAndAddRow(i)">
        </app-select-menu>
        <div class="linkedin-active" [style.visibility]="isRowEmpty(i) ? 'hidden' : 'visible'">
          <app-toggle-switch
            [enabled]="!!getIsActiveControl(i).value"
            (toggled)="getIsActiveControl(i).setValue($event)">
          </app-toggle-switch>
        </div>
        <div class="delete-bottom">
          <app-delete-btn *ngIf="!isRowEmpty(i) && terms.length > 1" (clicked)="removeRow(i)"></app-delete-btn>
        </div>
      </div>
      <div class="linkedin-fetch-info" *ngIf="getFetchInfo(i) as info">
        <span>{{ info.lastFetchDate ? 'Last fetched ' + info.lastFetchDate : 'Not fetched yet' }}<ng-container *ngIf="info.lastAdsCount !== null"> · {{ info.lastAdsCount }} ads</ng-container></span>
      </div>
      <div class="linkedin-row-error" *ngIf="isRowCountriesMissing(i)">Select at least one country for this term.</div>
      <div class="linkedin-row-error" *ngIf="isRowDuplicateTerm(i)">This term is already in the list.</div>
    </div>
  </div>
</div>
